import { Component, OnInit, Input } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-doble-tr-atajo-modal',
  templateUrl: './doble-tr-atajo-modal.component.html',
  styleUrls: ['./doble-tr-atajo-modal.component.css']
})
export class DobleTrAtajoModalComponent implements OnInit {

  dobleForm: FormGroup;
  @Input() data: any;
  constructor(public diaalogRef: MatDialogRef<DobleTrAtajoModalComponent>) { }

  ngOnInit(): void {
    this.initForm();
    console.log("Data", this.data);
  }

  initForm(): void{
    this.dobleForm = new FormGroup({
      tipoTramite : new FormControl('', Validators.required),
      tipoTramiteD : new FormControl('', Validators.required),
      nroVentas : new FormControl('', Validators.required),
      baseImponible: new FormControl('', Validators.required),
      nroCompra: new FormControl('', Validators.required),
      baseImponibleCompra: new FormControl('', Validators.required),
      numPedido: new FormControl(''),

    });
  }
}
